import { Translation } from 'cng-common/features/translations/components/translation'
import { Switch } from 'core-components/library/checkbox'

import styles from './NotApplicable.module.scss'

interface IProps {
  value: boolean
  canEdit: boolean
  onChange?: () => Promise<void>
  className?: string
  comment?: string
}

export const NotApplicableWidget = ({ value, canEdit, onChange, className, comment }: IProps) => {
  return (
    <div className={styles.root}>
      {canEdit && onChange && (
        <Switch
          className={className}
          padding
          checked={!value}
          onChange={async () => {
            if (onChange) await onChange()
          }}
        />
      )}
      {(value || canEdit) && (
        <div className={styles.status}>
          <Translation
            span
            text={
              value
                ? 'jbp-not-applicable-status-not-applicable'
                : 'jbp-not-applicable-status-applicable'
            }
          />
        </div>
      )}
      {comment ? ` - ${comment}` : ''}
    </div>
  )
}
